import type { TemplateFormData } from '../types/permit-template-types'
import { CheckListItemType } from '../types/permit-template-types'

export const templateWithDefaults: TemplateFormData = {
  id: '',
  templateId: '',
  name: '',
  type: '',
  address: '',
  description: '',
  cityKey: '',
  initialVersionName: '',
  requiredDocuments: [
    {
      id: '',
      name: '',
      description: '',
      isRequired: true,
      order: 1,
      entities: [
        {
          id: '',
          name: '',
          description: '',
          isRequired: true,
          order: 1,
          selectedItems: [
            {
              id: '',
              capabilityCheckId: '',
              checkListItemType: CheckListItemType.AdminCheck,
              order: 1,
              isRequired: true,
            },
          ],
        },
      ],
    },
  ],
}
